import { SupportedLocale } from '@amzn/red-velvet-api';
import { externalLinks } from '../data/externalLinks';
import { toOfferedLocale } from './localeUtils';

/**
 * Where a reader of each language goes to report a bad translation.
 *
 * One link per language rather than one link whose form this code assembles, so a language can be
 * served a form already written in it. English maps to nothing on purpose: English is the text
 * everything else is translated from, so a reader of it has no translation to report.
 *
 * Every language shares the English link until its own is written, which makes adopting one a
 * single-line edit here. Each language is listed rather than defaulted so that a newly supported
 * language has to be given a link deliberately instead of silently inheriting the English one.
 */
const FEEDBACK_URL_BY_LOCALE: Readonly<Record<SupportedLocale, string | undefined>> = {
  [SupportedLocale.EN_US]: undefined,
  [SupportedLocale.CS_CZ]: externalLinks.support.reportTranslationEnUs,
  [SupportedLocale.DE_DE]: externalLinks.support.reportTranslationEnUs,
  [SupportedLocale.ES_ES]: externalLinks.support.reportTranslationEnUs,
  [SupportedLocale.ES_MX]: externalLinks.support.reportTranslationEnUs,
  [SupportedLocale.ES_US]: externalLinks.support.reportTranslationEnUs,
  [SupportedLocale.FR_BE]: externalLinks.support.reportTranslationEnUs,
  [SupportedLocale.FR_CA]: externalLinks.support.reportTranslationEnUs,
  [SupportedLocale.FR_FR]: externalLinks.support.reportTranslationEnUs,
  [SupportedLocale.IT_IT]: externalLinks.support.reportTranslationEnUs,
  [SupportedLocale.JA_JP]: externalLinks.support.reportTranslationEnUs,
  [SupportedLocale.PL_PL]: externalLinks.support.reportTranslationEnUs,
  [SupportedLocale.PT_BR]: externalLinks.support.reportTranslationEnUs,
  [SupportedLocale.PT_PT]: externalLinks.support.reportTranslationEnUs,
};

/**
 * The report link for a language, or nothing when that language has none to offer.
 *
 * A language VC does not translate into gets nothing, the same as English: whatever a reader of it is
 * seeing did not come from a translator, so there is nothing for them to correct.
 */
export function translationFeedbackUrl(locale: string): string | undefined {
  const offeredLocale = toOfferedLocale(locale);

  return offeredLocale ? FEEDBACK_URL_BY_LOCALE[offeredLocale] : undefined;
}
